/* HeyBear · Product hero: 3D pouch + gallery, flavour switcher, pack size, quantity, add to cart,
   nutritional panel popup and the sticky add-to-cart bar. Flavour content comes from the heybear.* metafields
   (via #hb-data); prices and variant ids come from the real Shopify variants. */
HB.section('product-hero', function (root) {
  var $ = function (s) { return root.querySelector(s); }, $$ = function (s) { return [].slice.call(root.querySelectorAll(s)); };
  var off = [], on = function (el, ev, fn, o) { if (!el) return; el.addEventListener(ev, fn, o); off.push(function () { el.removeEventListener(ev, fn, o); }); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  var D = HB.data(), cfg = HB.config(), txt = root.dataset;
  var viewOnly = txt.viewOnly === 'true';
  var multiBuyEnabled = txt.multiBuyEnabled !== 'false';
  var multiBuyMinimum = +txt.multiBuyMin || 2;
  var multiBuyPrice = multiBuyEnabled ? (+txt.multiBuyPrice || 0) : 0;
  var cur = null, f = null, gi = 0, glist = [], qty = 1, selectedVariantId = null;
  var productRequests = {}, alive = true;

  /* The current product remains authoritative for its own purchase form, but
     collection membership alone controls whether it appears in flavour selectors. */
  var own = null;
  try { own = JSON.parse(($('[data-hb-product]') || {}).textContent || 'null'); }
  catch (e) { console.warn('[HeyBear] Could not read the enriched product data; using native Shopify variants.', e); }
  /* The compact native feed deliberately excludes metafields, so it remains a
     reliable purchase-state fallback if optional rich content contains bad data. */
  if (!own) {
    var nativeVariants = [];
    try { nativeVariants = JSON.parse(($('[data-hb-native-variants]') || {}).textContent || '[]'); }
    catch (e) { console.warn('[HeyBear] Could not read native Shopify variants.', e); }
    own = {
      key: txt.hbFlavour,
      handle: txt.productHandle,
      url: txt.productUrl,
      available: txt.productAvailable === 'true',
      demo: false,
      name: txt.productTitle,
      variants: nativeVariants.map(function (v, i) {
        return {
          id: v.id,
          title: v.title,
          price: v.price,
          compare: v.compare_at_price,
          available: v.available,
          order: i + 1,
          plans: []
        };
      })
    };
  }
  var validFlavourKeys = ['cola', 'apple', 'grape', 'strawberry', 'watermelon'];
  var ownIsMix = own && D.mix && own.handle && own.handle === D.mix.handle;
  if (own && own.key && !ownIsMix && validFlavourKeys.indexOf(own.key) !== -1) {
    var ownIndex = D.flavours.findIndex(function (x) { return x.key === own.key; });
    var previewFallback = ownIndex >= 0 ? D.flavours[ownIndex] : {};
    own = Object.assign({}, previewFallback, own, { demo: false });
    if (ownIndex >= 0) D.flavours.splice(ownIndex, 1, own);
    D.flavours.sort(function (a, b) { return (+a.sort || 999) - (+b.sort || 999); });
  } else own = null;
  var mixModeLink = $('#pModeMix');
  if (mixModeLink && D.mix && D.mix.url && !D.mix.demo) mixModeLink.href = D.mix.url;
  if (mixModeLink) mixModeLink.hidden = !(D.mix && D.mix.url);
  var mixCrossSell = $('#pCross');
  if (mixCrossSell) mixCrossSell.hidden = !(D.mix && D.mix.url);
  function variants(k) {
    if (own && own.key === k && own.variants && own.variants.length) return own.variants;
    return (HB.flavour(k) || {}).variants || [];
  }
  function orderedVariants() {
    var list = variants(cur).slice().sort(function (a, b) { return (+a.order || 999) - (+b.order || 999); });
    var threePacks = list.filter(function (v) { return v.role === 'three_pack' || +v.units === 3 || /-3$/i.test(v.sku || '') || HB.bags(v) === 3; });
    return threePacks.length ? threePacks : list.slice(0, 1);
  }
  function currentVariant() {
    var list = orderedVariants();
    return list.filter(function (v) { return String(v.id) === String(selectedVariantId); })[0] || list[0] || null;
  }
  function isPurchasable(v) {
    return !!(v && v.id && v.available === true && v.price != null);
  }
  function variantUnits(v) {
    if (v && +v.units > 0) return +v.units;
    var match = String(v && v.title || '').match(/\d+/);
    return match ? +match[0] : 3;
  }
  function variantLabel(v) {
    if (!v) return '';
    if (v.title && v.title !== 'Default Title') return v.title;
    return variantUnits(v) + '-Pack';
  }

  function productJsonUrl(url) {
    try {
      var parsed = new URL(url, location.href);
      parsed.pathname = parsed.pathname.replace(/\/$/, '') + '.js';
      parsed.search = '';
      parsed.hash = '';
      return parsed.href;
    } catch (_) { return ''; }
  }
  function syncProductAvailability(flavour) {
    var url = flavour && productJsonUrl(flavour.url);
    if (!url) return Promise.resolve(null);
    if (!productRequests[url]) {
      productRequests[url] = fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (response) {
        if (response.status === 404) return { unavailable: true };
        if (!response.ok) return null;
        return response.json();
      }).catch(function () { return null; });
    }
    root.setAttribute('aria-busy', 'true');
    return productRequests[url].then(function (live) {
      if (!alive || !live) return null;
      var existing = flavour.variants || [];
      if (live.unavailable) {
        existing.forEach(function (variant) { variant.available = false; });
        flavour.available = false;
        if (cur === flavour.key) { f = flavour; packs(); price(); }
        return live;
      }
      if (!live.variants) return null;
      flavour.variants = live.variants.map(function (variant, index) {
        var prior = existing.filter(function (item) { return String(item.id) === String(variant.id); })[0] || {};
        return Object.assign({}, prior, {
          id: variant.id,
          title: variant.title,
          sku: variant.sku || prior.sku,
          price: variant.price,
          compare: variant.compare_at_price,
          available: variant.available,
          units: prior.units || 3,
          role: prior.role || 'three_pack',
          order: prior.order || index + 1,
          plans: prior.plans || []
        });
      });
      flavour.handle = live.handle || flavour.handle;
      flavour.available = flavour.variants.some(isPurchasable);
      flavour.demo = false;
      if (own && own.key === flavour.key) own = flavour;
      if (cur === flavour.key) {
        f = flavour;
        packs();
        price();
      }
      return live;
    }).finally(function () {
      if (alive) root.removeAttribute('aria-busy');
    });
  }

  /* ---------- 3D pouch ---------- */
  var initialFlavour = HB.flavour(HB.pdp.current()) || (own && own.key === HB.pdp.current() ? own : {});
  var p3 = HB.mountPack($('#pPack'), { flavour: initialFlavour.k3, texture: initialFlavour.pouch });
  if (p3) {
    p3.setRotation(-14, { immediate: true });
    var pio = new IntersectionObserver(function (es) { p3.setIdle(es[0].isIntersecting); }); pio.observe($('#pPack'));
    off.push(function () { pio.disconnect(); });
    on(window, 'scroll', function () { var r = $('#pStage').getBoundingClientRect(); p3.setRotation(-14 + Math.max(-40, Math.min(40, -r.top * 0.08))); }, { passive: true });
  }

  /* ---------- flavour selector (all flavour products, sorted by heybear.sort_order) ---------- */
  $('#pFlavs').innerHTML = D.flavours.map(function (x) {
    return '<button type="button" class="pf" role="radio" data-f="' + x.key + '" aria-checked="false"><img src="' + x.pack + '" alt="">' + esc(x.name) + '</button>';
  }).join('');
  on($('#pFlavs'), 'click', function (e) { var b = e.target.closest('.pf'); if (b) HB.pdp.go(b.getAttribute('data-f')); });

  /* flavour links anywhere on the page (mega menu, cards) switch in place */
  on(document, 'click', function (e) {
    if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.button) return;
    var a = e.target.closest('a[href]'); if (!a || a.target === '_blank') return;
    var u; try { u = new URL(a.href, location.href); } catch (_) { return; }
    if (u.origin !== location.origin) return;
    var hit = D.flavours.filter(function (x) { return x.url && !x.demo && u.pathname.replace(/\/$/, '') === new URL(x.url, location.href).pathname.replace(/\/$/, ''); })[0];
    if (!hit) return;
    e.preventDefault(); HB.pdp.go(hit.key);
    window.scrollTo({ top: 0, behavior: HB.reduce ? 'auto' : 'smooth' });
  });

  /* ---------- gallery ---------- */
  function buildGallery() {
    glist = (f.photos || []).slice();
    $('#pThumbs').innerHTML = '<button type="button" class="pk" role="tab" aria-label="3D pouch"><img src="' + f.pack + '" alt=""><span class="t3d">3D</span></button>' +
      glist.map(function (src, i) { return '<button type="button" role="tab" aria-label="Photo ' + (i + 1) + '"><img src="' + src + '" alt="" loading="lazy"></button>'; }).join('');
    [].slice.call($('#pThumbs').children).forEach(function (b, i) { b.addEventListener('click', function () { showG(i); }); });
    showG(0);
  }
  function showG(i) {
    var n = glist.length + 1; gi = (i + n) % n;
    [].slice.call($('#pThumbs').children).forEach(function (b, k) { b.setAttribute('aria-selected', k === gi); });
    $('#pPh').hidden = gi === 0; $('#pStage').classList.toggle('photo', gi > 0);
    if (gi > 0) { $('#pPhImg').src = glist[gi - 1]; $('#pPhImg').alt = 'HeyBear ' + f.name + ' product photo'; }
    $('#pCount').textContent = (gi + 1) + ' / ' + n;
  }
  on($('#pPrev'), 'click', function () { showG(gi - 1); });
  on($('#pNext'), 'click', function () { showG(gi + 1); });
  var sx = null;
  on($('#pPh'), 'pointerdown', function (e) { sx = e.clientX; });
  on($('#pPh'), 'pointerup', function (e) { if (sx != null && Math.abs(e.clientX - sx) > 40) showG(gi + (e.clientX < sx ? 1 : -1)); sx = null; });

  /* ---------- apply a flavour ---------- */
  function setText(sel, v) { $$(sel).forEach(function (el) { el.textContent = v; }); }
  function apply(k) {
    cur = k; f = HB.flavour(k) || (own && own.key === k ? own : null); if (!f) return;
    var R = document.documentElement.style;
    R.setProperty('--fbg', f.bg); R.setProperty('--fac', f.ac); R.setProperty('--fdeep', f.deep); R.setProperty('--fsoft', f.soft); R.setProperty('--fpop', f.pop);
    if (!root.__first) root.__first = true; else document.title = f.name + ' – ' + (txt.shop || 'HeyBear');
    $$('#pFlavs .pf').forEach(function (b) { b.setAttribute('aria-checked', b.getAttribute('data-f') === k); });
    setText('#pfName,#dFlav,#dFlav2,#npFlav,#crumbName,#pName', f.name);
    setText('#pLine', f.line); setText('#pDesc', f.desc);
    var waitlistTags = $('#hbProductWaitlistTags');
    if (waitlistTags) waitlistTags.value = 'product-waitlist,' + (f.handle || f.key);
    var at = $('#accTaste'); if (at) at.textContent = f.note;
    var ah = $('#accHighlights'); if (ah && f.highlights) ah.innerHTML = f.highlights;
    $('#fltA').src = f.gummy; $('#fltB').src = f.gummy;
    if (p3) { p3.setFlavour(f.k3, f.pouch); p3.setRotation(-14); }
    buildGallery();
    /* nutritional panel: heybear.nutrition_panel / heybear.ingredients when filled in, otherwise the section defaults */
    var rich = $('#npRich'), def = $('#npDefault'), ingr = $('#npIngr');
    if (rich && def) { rich.innerHTML = f.np || ''; rich.hidden = !f.np; def.hidden = !!f.np; }
    if (ingr) ingr.innerHTML = f.ingr || '<p>' + esc(ingr.getAttribute('data-placeholder') || '').replace('[flavour]', '<span id="dFlav2">' + esc(f.name) + '</span>') + '</p>';
    /* mixed-pack cross sell */
    var mixV = D.mix && HB.variantMatch(D.mix, /cub/i), from = mixV ? HB.money(mixV.price) : '';
    $('#crossH').textContent = f.mix ? txt.crossHMix : txt.crossHSolo;
    $('#crossS').textContent = String(f.mix ? txt.crossSMix : txt.crossSSolo).replace('[flavour]', f.name).replace('[price]', from);
    if (D.mix && D.mix.url && !D.mix.demo) $('#pCrossLink').href = D.mix.url;
    $('#stImg').src = f.pack;
    packs(); price();
    syncProductAvailability(f);
  }

  /* ---------- pack sizes, price, buy ---------- */
  function packs() {
    var list = orderedVariants();
    var selected = list.filter(function (v) { return String(v.id) === String(selectedVariantId); })[0];
    if (!isPurchasable(selected)) selected = list.filter(isPurchasable)[0] || list[0];
    selectedVariantId = selected && selected.id;
    $('#pPacks').innerHTML = list.map(function (v, index) {
      var units = variantUnits(v), checked = String(v.id) === String(selectedVariantId), disabled = !isPurchasable(v);
      var note = v.note || (units + ' × ' + ((f.facts && f.facts.bag) || '102g'));
      var badge = v.badge ? '<span class="flag">' + esc(v.badge) + '</span>' : '';
      var stock = disabled ? '<span class="p-stock-status">' + esc(txt.soldOut || 'Sold out') + '</span>' : '';
      var priceText = v.price == null ? '' : HB.money(v.price);
      var bagText = v.price == null ? '' : '<small data-bag>' + HB.money(v.price / Math.max(1, units)) + ' / bag</small>';
      return '<label class="p-pack" data-variant="' + esc(v.id) + '">' + badge +
        '<input type="radio" name="pp" value="' + esc(v.id) + '"' + (checked ? ' checked' : '') + (disabled ? ' disabled' : '') + '>' +
        '<b>' + esc(variantLabel(v)) + '</b><small>' + esc(note) + '</small><span class="pp">' + priceText + '</span>' +
        bagText + stock + '</label>';
    }).join('');
  }
  function price() {
    var v = currentVariant(), base = v ? v.price : 0, unit = qty >= multiBuyMinimum && multiBuyPrice ? multiBuyPrice : base, t = unit * qty;
    $('#pPrice').textContent = HB.money(t); $('#qVal').textContent = qty;
    $('#stName').textContent = f.name + (v ? ' · ' + variantLabel(v) : '');
    $('#stPrice').textContent = HB.money(t) + (qty > 1 ? ' (' + qty + ' × ' + HB.money(unit) + ')' : '');
    var multi = $('#pMulti'); if (multi) { multi.hidden = !multiBuyEnabled || !v || v.price == null; multi.classList.toggle('active', !multi.hidden && qty >= multiBuyMinimum); }
    var tot = HB.cartTotal() + t, left = Math.max(0, cfg.freeAt - tot);
    $('#pShipTxt').textContent = left > 0 ? String(txt.shipLeft).replace('[amount]', HB.money(left)) : txt.shipDone;
    $('#pShipBar').style.width = Math.min(100, tot / cfg.freeAt * 100) + '%';
    var sold = viewOnly || !isPurchasable(v);
    $('#pAdd').disabled = $('#stAdd').disabled = !!sold;
    $('#pAddLabel').textContent = sold ? (txt.soldOut || 'Sold out') : (txt.add || 'Add to cart'); $('#pPriceWrap').hidden = !!sold;
    $('#pBuyRow').hidden = sold; $('#pShip').hidden = sold; $('#pSoldOut').hidden = !sold; $('#pSticky').hidden = sold;
  }
  on($('#pPacks'), 'change', function (e) {
    if (!e.target.matches('input[name=pp]')) return;
    selectedVariantId = e.target.value;
    price();
  });
  on($('#qMinus'), 'click', function () { qty = Math.max(1, qty - 1); price(); });
  on($('#qPlus'), 'click', function () { qty = Math.min(20, qty + 1); price(); });
  on(document, 'hb:cart:updated', function () { if (f) price(); });

  function add(e) {
    var v = currentVariant(), btn = e.currentTarget;
    if (viewOnly || !isPurchasable(v)) return;
    HB.cart.add([{ id: v && v.id, quantity: qty }]).then(function () {
      var wait = HB.flyToCart(btn, f.ac);
      setTimeout(HB.cart.open, Math.max(250, wait));
    }).catch(function (error) {
      productRequests[productJsonUrl(f && f.url)] = null;
      syncProductAvailability(f);
      HB.toast(error && error.message ? error.message : (txt.soldOut || 'Sold out'));
    });
  }
  on($('#pAdd'), 'click', add); on($('#stAdd'), 'click', add);
  var waitlistForm = $('#hbProductWaitlist');
  if (waitlistForm) on(waitlistForm, 'submit', function () {
    var button = waitlistForm.querySelector('button[type="submit"]');
    if (!button) return;
    button.disabled = true;
    button.textContent = button.getAttribute('data-loading-label') || 'Joining…';
    waitlistForm.setAttribute('aria-busy', 'true');
  });

  /* ---------- nutritional panel popup ---------- */
  var dlg = $('#npDlg');
  on($('#npOpen'), 'click', function () { if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', ''); });
  on($('#npClose'), 'click', function () { if (dlg.close) dlg.close(); else dlg.removeAttribute('open'); });
  on(dlg, 'click', function (e) { if (e.target === dlg && dlg.close) dlg.close(); });

  /* ---------- sticky add-to-cart bar (hidden once the footer is in view) ---------- */
  var sticky = $('#pSticky');
  var stState = function () {
    if (sticky.hidden) { sticky.classList.remove('show'); return; }
    var a = $('#pAdd').getBoundingClientRect(), fz = document.querySelector('.club'), atFoot = fz && fz.getBoundingClientRect().top < innerHeight - 40;
    sticky.classList.toggle('show', a.bottom < 0 && !atFoot);
  };
  on(window, 'scroll', stState, { passive: true }); on(window, 'resize', stState); stState();

  off.push(HB.pdp.on(function (k) { apply(k); }));
  return function () { alive = false; off.forEach(function (fn) { fn(); }); };
});
